import { render, staticRenderFns } from "./Weixin.vue?vue&type=template&id=f2b9176c&scoped=true"
import script from "./Weixin.vue?vue&type=script&lang=js"
export * from "./Weixin.vue?vue&type=script&lang=js"
import style0 from "./Weixin.vue?vue&type=style&index=0&id=f2b9176c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b9176c",
  null
  
)

export default component.exports